module.exports = __webpack_public_path__ + "img/computer.a1426f24.png";